export enum Locales {
  EN_AU = 'en-AU',
  EN_NZ = 'en-NZ',
}
